import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97d63128"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = {
  key: 0,
  class: "centre-text"
}
const _hoisted_4 = ["href"]

import { computed } from "vue";
import Popup from "./Popup.vue";
import ICustomerTermsConsent from "@/Interfaces/Contract/ICustomerTermsConsent";
import Table from "@/components/TablePersistentChecking.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HireAgreementPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const cols: (keyof ICustomerTermsConsent)[] = [
    "contractID",
    "documentType",
    "fileReference",
    "documentVersion",
    "consentDatetime"
];
const props = __props;
const emits = __emit;
const secondaryTableData = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
function closeChild() {
    secondaryTableData.value = undefined;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!secondaryTableData.value,
    "onUpdate:modelValue": closeChild,
    title: "T&C Consent Table",
    hasClose: ""
  }, _createSlots({ _: 2 }, [
    (secondaryTableData.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(Table, {
                  Rows: secondaryTableData.value,
                  Cols: cols,
                  SplitColKeys: ""
                }, {
                  fileReference: _withCtx(({ value }) => [
                    (value.fileReference)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (value.fileReference)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: value.fileReference,
                                target: "_blank",
                                class: "linkTextStyle"
                              }, "File Link 🔗", 8, _hoisted_4))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  consentDatetime: _withCtx(({ value }) => [
                    _createTextVNode(_toDisplayString(value.consentDatetime.replace('T', ' ')), 1)
                  ]),
                  _: 1
                }, 8, ["Rows"])
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})